import {PropsWithChildren} from 'react';
import ReactDOM from 'react-dom';

export type PortalProps = PropsWithChildren<{}>

export function Portal({children}: PortalProps) {
  return typeof document === 'object' ? ReactDOM.createPortal(children, document.body) : null;
}
